import React from 'react';
import { Link } from 'react-router-dom';
const BookingDoneComp = () => {
  return (
    <> 
        <div>
          <div>
            <div className='md:w-[50%] md:py-16 mx-auto'>
              <h1 className='text-[#409BF5]  font-bold text-6xl text-center '>Booking Done !</h1>
              <p className='text-[#6A7D95] text-lg text-center py-6' >Lorem ipsum dolor sit amet, consectetur adipiscing elit.
               Praesent odio felis, pulvinar non iaculis sed, dignissim 
               eget nulla. Integer id volutpat ipsum. Sed efficitur lobortis
                aliquam. In porttitor efficitur nibh vel lobortis. Nullam rhoncus
                 nunc id ex placerat,   </p>
                 <div className=' py-6 '>
                 <center>
                 <Link to='/' >  <button className='mx-2 text-sm text-blue-500'>  Return to Home</button></Link>
             <Link to='/RateUs' > <button className='mx-2 text-xs bg-blue-400 text-gray-200 py-3 px-6 rounded-lg'> Download Receipt</button></Link>
              </center>
            </div>
            </div>
           
          </div>
        </div>
    </>
  )
}

export default BookingDoneComp